<template>
  <nav
    :class="{ 'scroll-to-top--is-visible': !isScrollingDown }"
    class="scroll-to-top"
    aria-labelledby="scroll-to-top"
  >
    <a class="circle-button" href="#skip-nav" @click="scrollToTop">
      <dpc-icon
        class="circle-button__icon"
        icon="arrow-up"
        custom-label="Zum Seitenanfang"
      ></dpc-icon>
    </a>
  </nav>
</template>

<script>
import { useWindowScroll } from '@vueuse/core';
import { ref, watch } from 'vue';

const SCROLLCONFIG = {
  behavior: 'smooth',
  block: 'start',
  inline: 'start',
};

export default {
  setup() {
    const { y } = useWindowScroll();

    const lastY = ref(y.value);
    const isScrollingDown = ref(true);
    watch(y, y => {
      isScrollingDown.value = lastY.value < y || y === 0;
      lastY.value = y;
    });

    return {
      isScrollingDown,
    };
  },
  methods: {
    scrollToTop(e) {
      e.preventDefault();
      // const target = document.querySelector(e.target.hash);
      document.body.setAttribute('tabindex', -1);
      document.body.focus();
      document.body.scrollIntoView(SCROLLCONFIG);
    },
  },
};
</script>
